import React from "react";

//* Import Component
import PaneMenu from "./PaneMenu";
import NodeMenu from "./NodeMenu";

const ContextMenu = ({ pane = false, ...props }) => {
  return <>{pane ? <PaneMenu {...props} /> : <NodeMenu {...props} />}</>;
};

export default ContextMenu;
